import React from 'react';
import './drop-down-item.css';
import { motion } from 'framer-motion'
const iconVariant = {
  hover : {
    rotate: -60,
    transition : {
      delay: 0.3,
      duration: 0.3,
    }
  }
}
const DropDownItem = ({ icon, itemName, detail }) => {
  return (
    <div className="drop-item">
      <motion.i className={icon}
        variants={iconVariant}
        whileHover="hover"></motion.i>
      <div className="drop-text">
        <p className="drop-header">{itemName}</p>
        <p className="drop-detail">{detail}</p>
      </div>
    </div>
  );
};

export default DropDownItem;
